import { SvgWarning } from '../assets/images'
import CustomButton from './CustomButton'
import Modal from './Modal'

interface CustomConfirmationModalPropsType {
  open: boolean
  handleClose: () => void
  width?: string
  title?: string
  cancelButtonText?: string
  confirmButtonText?: string
  onConfirm: () => void
  message?: string
}

const CustomConfirmationModal = ({
  open,
  handleClose,
  width,
  title,
  cancelButtonText = 'Cancel',
  confirmButtonText = 'Confirm',
  onConfirm,
  message,
}: CustomConfirmationModalPropsType) => {
  return (
    <Modal isOpen={open} closeModal={handleClose} width={width}>
      <div className="flex flex-col gap-4">
        <div className="flex flex-col items-center gap-3">
          <div className="flex flex-col items-center gap-5">
            <div className="flex bg-error-100 rounded-full w-12 h-10 items-center justify-center">
              <SvgWarning />
            </div>
            {title && (
              <div className="font-medium font-primary text-accent-900">
                {title}
              </div>
            )}
          </div>
          {message && (
            <div className="font-light font-primary text-center text-xs/4.5 text-accent-900">
              {message}
            </div>
          )}
        </div>
        <div className={`flex flex-col gap-3 items-center`}>
          <CustomButton
            dataQaId="custom-button-cancel-confirm-modal"
            onClick={handleClose}
            color="primary"
            className="border border-primary-500 text-xs"
            widthClass="w-1/2"
          >
            {cancelButtonText}
          </CustomButton>
          <CustomButton
            dataQaId="custom-button-accept-confirm-dialog"
            onClick={onConfirm}
            color="primary"
            isFilled={true}
            widthClass="w-1/2"
          >
            {confirmButtonText}
          </CustomButton>
        </div>
      </div>
    </Modal>
  )
}

export default CustomConfirmationModal
